// export const PAY_URL = "http://localhost:8000/api";

// export const PDF_URL = "http://localhost:8000";

export const PDF_URL = "https://api.pranhans.com/";
export const PAY_URL = "https://api.pranhans.com/api";
